import React from 'react';
import PropTypes from 'prop-types';

const Input = ({ isDisabled, input, handleSubmit, setInput, isRecording, toggleRecording }) => {
    const handleMicClick = (e) => {
        e.preventDefault(); // Prevent form submission
        toggleRecording();
    };
    return (
        <form className="inputForm" onSubmit={handleSubmit}>
            <input
                placeholder="Enter Message"
                type="text"
                className="form-control-input"
                value={input}
                onChange={(e) => setInput(e.target.value)}
                disabled={isDisabled}
                maxLength={200}
            />
            {/*<button 
                type="button" 
                className="micButton" 
                onClick={handleMicClick} 
                disabled={isDisabled}
            >
                <span className="material-icons-outlined">
                    {isRecording ? 'mic_off' : 'mic'}
                </span>
            </button>*/}
            <button className="inputButton" disabled={isDisabled}>
                <span className="material-icons-outlined">send</span>
            </button>
        </form>
    );
}

Input.propTypes = {
    isDisabled: PropTypes.bool,
    input: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    setInput: PropTypes.func.isRequired,
    isRecording: PropTypes.bool.isRequired,
    toggleRecording: PropTypes.func.isRequired,
}

export default Input;